var _path, _path2, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConservativeGauge = function SvgConservativeGauge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 90,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#conservative-gauge_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2D2C",
    d: "M7.49 76.558c1.62 0 2.7-.936 3.024-2.466h3.132c-.396 3.168-2.808 5.31-6.138 5.31-3.69 0-6.48-2.664-6.48-6.354s2.79-6.354 6.48-6.354c3.33 0 5.742 2.142 6.138 5.31h-3.132c-.324-1.53-1.404-2.466-3.024-2.466-1.998 0-3.384 1.476-3.384 3.51s1.386 3.51 3.384 3.51m12.12-6.354c2.809 0 4.789 1.926 4.789 4.608 0 2.7-1.98 4.59-4.788 4.59s-4.806-1.89-4.806-4.59c0-2.682 1.998-4.608 4.806-4.608m0 6.768c1.207 0 2.053-.882 2.053-2.16 0-1.26-.846-2.16-2.052-2.16-1.224 0-2.07.9-2.07 2.16 0 1.278.846 2.16 2.07 2.16m11.554-6.768c2.196 0 3.708 1.494 3.708 3.978v4.986h-2.916V74.65c0-1.242-.63-1.8-1.602-1.8-.522 0-1.08.27-1.584.828v5.49h-2.934v-8.73h2.934v.576c.702-.522 1.458-.81 2.394-.81m7.586 5.976c.126.756.81 1.08 1.728 1.08.774 0 1.26-.216 1.26-.594 0-.306-.342-.522-.918-.612l-1.764-.306c-1.494-.252-2.556-1.098-2.556-2.628 0-1.836 1.566-2.916 3.888-2.916 2.07 0 3.942.702 4.068 3.006h-2.574c-.054-.648-.684-.936-1.494-.936-.756 0-1.098.27-1.098.594 0 .306.216.576.918.702l1.62.27c1.62.306 2.718 1.098 2.718 2.646 0 2.016-1.8 2.916-4.086 2.916-2.25 0-4.104-.918-4.302-3.24zm11.423-5.976c3.078 0 4.932 2.196 4.5 5.292h-6.318c.198.9.792 1.602 1.98 1.602.648 0 1.026-.144 1.296-.468h2.952c-.522 1.71-2.142 2.772-4.194 2.772-2.862 0-4.77-1.944-4.77-4.608 0-2.646 1.854-4.59 4.554-4.59m.072 2.16c-1.026 0-1.62.576-1.854 1.458h3.636c-.162-1.008-.792-1.458-1.782-1.458m11.888-2.07v2.772c-1.422.054-2.322.432-3.006 1.098v5.004h-2.934v-8.73h2.934v.936c.774-.666 1.71-1.08 3.006-1.08m7.887.144h3.078l-3.78 8.73h-2.772l-3.78-8.73h3.078l2.088 5.04zm9.859 0h2.916v8.73h-2.916V78.7c-.648.432-1.422.702-2.394.702-2.358 0-4.338-2.016-4.338-4.608 0-2.61 1.98-4.59 4.338-4.59.972 0 1.746.252 2.394.684zm-1.8 6.48c.63 0 1.242-.162 1.8-.774v-2.7c-.558-.612-1.17-.774-1.8-.774-1.188 0-2.07.918-2.07 2.124s.882 2.124 2.07 2.124m13.374-.558.324 2.61c-.9.378-1.836.432-2.34.432-2.376 0-3.816-1.548-3.816-3.906V72.94h-1.71v-2.502h1.71v-2.97h2.916v2.97h2.97v2.502h-2.97v2.466c0 .9.522 1.314 1.368 1.314.558 0 1.026-.162 1.548-.36m3.487-7.29c-.954 0-1.71-.702-1.71-1.638 0-.954.756-1.656 1.71-1.656.936 0 1.71.702 1.71 1.656 0 .936-.774 1.638-1.71 1.638m-1.44 1.368h2.916v8.73H93.5zm11.413 0h3.078l-3.78 8.73h-2.772l-3.78-8.73h3.078l2.088 5.04zm7.68-.234c3.078 0 4.932 2.196 4.5 5.292h-6.318c.198.9.792 1.602 1.98 1.602.648 0 1.026-.144 1.296-.468h2.952c-.522 1.71-2.142 2.772-4.194 2.772-2.862 0-4.77-1.944-4.77-4.608 0-2.646 1.854-4.59 4.554-4.59m.072 2.16c-1.026 0-1.62.576-1.854 1.458h3.636c-.162-1.008-.792-1.458-1.782-1.458"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-gauge_svg__b",
    width: 118,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.645 0h116.38v57.151H.645z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-gauge_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "conservative-gauge_svg__c",
    width: 118,
    height: 117,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 58.781,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-gauge_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA8B8",
    stroke: "#FFA8B8",
    d: "m53.76 52.969 3.41-1.2L40.244 2.211l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-gauge_svg__d",
    width: 118,
    height: 117,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 58.781,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-gauge_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD8FA4",
    stroke: "#FD8FA4",
    d: "M57.12 49.86 40.226-.115 58.629-4.37 77.71-.556 61.28 50.113z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-gauge_svg__e",
    width: 118,
    height: 117,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 58.781,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-gauge_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D93657",
    stroke: "#D93657",
    d: "M106.952 22.815 68.34 49.19l3.868 7.525h46.347l-3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-gauge_svg__f",
    width: 118,
    height: 117,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 58.781,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-gauge_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1E7",
    stroke: "#FFE1E7",
    d: "M10.716 22.815 49.328 49.19l-3.868 7.525H-.887l3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-gauge_svg__g",
    width: 118,
    height: 117,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 58.781,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-gauge_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC6481",
    stroke: "#FC6481",
    d: "m65.199 51.566-3.43-1.143L77.872.59l18.484 8.671 10.862 13.721z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.833,
    cy: 58.787,
    r: 26.263,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m47.912 46.208 1.042-5.296 5.419 1.066M59.172 55.727l-9.367-13.583"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "conservative-gauge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h118v90H0z"
  })))));
};
export { SvgConservativeGauge as ReactComponent };
export default __webpack_public_path__ + "images/conservative-gauge.svg";